import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '@ami/react/core';
import { MachineMake } from '../machines/machineMake';
import MachineMakeFilter from '../machines/machineMakeFilter';

export class MachineMakeDropdown extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    selectedId: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    isClearable: PropTypes.bool,
    className: PropTypes.string,
    carrierId: PropTypes.string,
    weightCategoryId: PropTypes.string,
  };

  state = {
    makes: [],
  };

  async componentDidMount() {
    await this.loadMakes();
  }

  async componentDidUpdate(prevProps) {
    if (
      prevProps.carrierId !== this.props.carrierId ||
      prevProps.weightCategoryId !== this.props.weightCategoryId
    ) {
      await this.loadMakes();
    }
  }

  loadMakes = async () => {
    const makes = await MachineMake.search(
      new MachineMakeFilter({
        carrierId: this.props.carrierId,
        weightCategoryId: this.props.weightCategoryId,
      })
    );
    this.setState({
      makes: makes.map((x) => ({
        id: x.name,
        label: x.name,
      })),
    });
  };

  render() {
    const {
      placeholder,
      selectedId,
      onChange,
      isClearable,
      className,
      ...rest
    } = this.props;
    const { makes } = this.state;
    return (
      <Dropdown
        placeholder={placeholder || 'All'}
        items={makes}
        selectedId={selectedId}
        onChange={onChange}
        isClearable={isClearable}
        className={className}
        forceSearchable={true}
        {...rest}
      />
    );
  }
}
